export const UNIT_TYPE = {
  GENERAL_OPTIONS:"generalOptions",
  MONTH_OPTIONS :"monthOptions"
};